import TopupDepositView from 'src/sections/overview/topup-deposit/view/topup-deposit-view';

export default function TopupDeposit() {
  return <TopupDepositView />;
}
